"use strict";

const ACK_KEY='kan_cookie_ack_v1';

function AddStyles()
	{
	if (document.getElementById('kan-cookie-notice-style')) return;
	const style=document.createElement('style');
	style.id='kan-cookie-notice-style';
	style.textContent=`
.kan-cookie-notice {
	position: fixed;
	left: 50%;
	bottom: max(14px, env(safe-area-inset-bottom));
	transform: translateX(-50%);
	width: min(720px, calc(100vw - 24px));
	box-sizing: border-box;
	z-index: 10000;
	display: grid;
	grid-template-columns: 1fr auto auto;
	gap: 12px;
	align-items: center;
	padding: 12px 14px;
	border: 1px solid rgba(255,177,70,0.65);
	background: rgba(5,5,8,0.96);
	box-shadow: 0 10px 36px rgba(0,0,0,0.55);
	color: #fdf4e8;
	font-family: Arial, Helvetica, sans-serif;
	font-size: 13px;
	line-height: 1.35;
}
.kan-cookie-notice a {
	color: #ffb146;
	text-decoration: underline;
}
.kan-cookie-notice button {
	border: 1px solid #ffb146;
	background: #ffb146;
	color: #110704;
	cursor: pointer;
	font-weight: 700;
	padding: 8px 12px;
	font-size: 13px;
}
.kan-cookie-notice .kan-cookie-link {
	background: transparent;
	color: #ffb146;
}
@media (max-width: 640px) {
	.kan-cookie-notice {
		grid-template-columns: 1fr;
	}
	.kan-cookie-notice button {
		width: 100%;
	}
}`;
	document.head.appendChild(style);
	}

export function ShowCookieNotice(options={})
	{
	try
		{
		if (localStorage.getItem(ACK_KEY)==='true') return;
		}
	catch (_) {}

	if (document.getElementById('kan-cookie-notice')) return;
	AddStyles();

	const privacyHref=options.privacyHref||'/privacy';
	const cookiesHref=options.cookiesHref||'/cookies';
	const root=document.createElement('div');
	root.id='kan-cookie-notice';
	root.className='kan-cookie-notice';
	root.setAttribute('role','status');
	root.innerHTML=`
	<div>Kanoogi uses essential cookies and browser storage to keep you signed in, connect you across Kanoogi services, and launch games. We do not use advertising cookies. <a href="${privacyHref}">Privacy</a></div>
	<a class="kan-cookie-link" href="${cookiesHref}">Cookies</a>
	<button type="button">Got it</button>`;

	const button=root.querySelector('button');
	button.addEventListener('click',()=>
		{
		try { localStorage.setItem(ACK_KEY,'true'); } catch (_) {}
		root.remove();
		});

	document.body.appendChild(root);
	}
